export default __webpack_public_path__ + "static/media/node.8755afe2.png";